import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay } from '@/test/mocks/utils';

import { LeaderBoardResponse } from '../types';

export const getLeaderBoard = (grade: string): Promise<LeaderBoardResponse> => {
  return axios.get(`/assessment/v1/users/reports/get-leaderboard/${grade}`);
};

export const getLeaderBoardMockHandler = http.get(
  `${env.API_URL}/assessment/v1/users/reports/get-leaderboard/:grade`,
  async (): Promise<HttpResponse<LeaderBoardResponse>> => {
    await networkDelay();

    const mockResponse: LeaderBoardResponse = {
      status: 'success',
      responseBody: {
        overallRanking: 15,
        coinsEarnedHighest: 1250,
        topPerformers: [
          {
            rank: 1,
            totalCoinsEarned: 1250,
            userName: 'MathWizard',
          },
          {
            rank: 2,
            totalCoinsEarned: 1100,
            userName: 'NumberNinja',
          },
          {
            rank: 3,
            totalCoinsEarned: 980,
            userName: 'CalcChamp',
          },
          {
            rank: 4,
            totalCoinsEarned: 865,
            userName: 'AlgebraAce',
          },
          {
            rank: 5,
            totalCoinsEarned: 750,
            userName: 'GeometryGuru',
          },
        ],
        topUserPerformedTopics: [
          {
            rank: 1,
            totalCoinsEarned: 320,
            name: 'Place Value',
          },
          {
            rank: 2,
            totalCoinsEarned: 285,
            name: 'Addition & Subtraction',
          },
          {
            rank: 3,
            totalCoinsEarned: 245,
            name: 'Multiplication',
          },
        ],
        topUserPerformedModules: [
          {
            rank: 1,
            totalCoinsEarned: 450,
            name: 'Numbers & Operations',
          },
          {
            rank: 2,
            totalCoinsEarned: 380,
            name: 'Algebra Basics',
          },
          {
            rank: 3,
            totalCoinsEarned: 310,
            name: 'Geometry Fundamentals',
          },
        ],
      },
    };

    return HttpResponse.json(mockResponse);
  }
);
